/**
 * Tailwind class-name combiner. Merges variant classes from cva() with
 * caller-supplied overrides, using tailwind-merge to dedupe conflicting
 * utilities (`p-2` + `p-4` → `p-4` instead of both).
 *
 * Standard shadcn/ui pattern — re-export here so component files don't
 * each grow an inline copy.
 */

import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Our fontSize scale uses custom keys (`text-caption`, `text-body-sm`, …).
 * tailwind-merge only knows its own scale, so it read `text-caption` as a
 * text *colour* and dropped the colour that came before it — `bg-accent
 * text-cream … text-caption` silently lost `text-cream`, leaving the label
 * to inherit the page's text colour. Teaching it the scale keeps both.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        { text: ['display', 'h1', 'h2', 'h3', 'body-lg', 'body', 'body-sm', 'caption'] },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
